import { NgModule, Injectable } from '@angular/core';
import {
    Routes,
    RouterModule,
    CanDeactivate
} from '@angular/router';

import { BaseComponent } from './base/base.component';
import { CreepToolComponent } from './creep-tool/creep-tool.component';
import { CreepsComponent } from './creeps/creeps.component';
import { PowerCreepsAvailableComponent } from './power-creeps-available';

import { CreepsResolver } from './creeps.resolver';

@Injectable()
export class CanDeactivateCreepTool implements CanDeactivate<CreepToolComponent> {
    canDeactivate(
        creepTool: CreepToolComponent
    ): Promise<any> {
        return new Promise(async (resolve) => {
            try {
                await creepTool.reset();
                resolve(true);
            } catch (err) {
                resolve(false);
            }
        });
    }
}

const routes: Routes = [
    {
        path: 'overview/power',
        component: BaseComponent,
        children: [{
            path: '',
            component: CreepsComponent,
            resolve: {
                creeps: CreepsResolver
            },
            children: [{
                path: ':creepId',
                component: CreepToolComponent,
                canDeactivate: [CanDeactivateCreepTool]
            }]
        }]
    }, {
        path: 'power-promo',
        component: PowerCreepsAvailableComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [CanDeactivateCreepTool]
})
export class PowerRoutingModule { }
